import { render, staticRenderFns } from "./Error502.vue?vue&type=template&id=80bc24ce&scoped=true"
import script from "./Error502.vue?vue&type=script&lang=js"
export * from "./Error502.vue?vue&type=script&lang=js"
import style0 from "./Error502.vue?vue&type=style&index=0&id=80bc24ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc24ce",
  null
  
)

export default component.exports